module.exports = __webpack_public_path__ + "static/media/front-wedding.1ed2ccd8.jpg";